/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ods-form-header',
  host: { class: 'flex flex-1 flex-col gap-4 text-text' },
  template: `
    @switch (headingLevel) {
      @case (1) {
        <h1 class="heading-1" data-test-id="form-header-heading">{{ heading }}</h1>
      }
      @case (2) {
        <h2 class="text-2xl font-medium" data-test-id="form-header-heading">{{ heading }}</h2>
      }
    }
    <ng-content />
  `,
})
export class FormHeaderComponent {
  @Input({ required: true }) heading: string;
  @Input() headingLevel: 1 | 2 = 2;
}
